import React from 'react';
import { Form } from 'react-bootstrap';
import { AssetMaintenancePhotos } from './AssetMaintenancePhotos';

export function AssetPmTaskEditor({
    tasks,
    onChange,
    disabled,
    kind,
    scheduleId,
    revision,
    onPhotos,
    onPhotoState,
    onPhotoConflict,
}) {
    return (
        <div>
            {tasks.map((task) => (
                <Form.Group key={task.seq} className="mb-3">
                    <Form.Label htmlFor={'pm-task-' + task.seq}>
                        Task {task.seq} description
                    </Form.Label>
                    <Form.Control
                        as="textarea"
                        id={'pm-task-' + task.seq}
                        value={task.description}
                        maxLength={2000}
                        disabled={disabled}
                        onChange={(event) => onChange(task.seq, event.target.value)}
                    />
                    {kind ? (
                        <AssetMaintenancePhotos
                            kind={kind}
                            parentType="schedule"
                            parentId={scheduleId}
                            taskSeq={task.seq}
                            revision={revision}
                            attachmentIds={task.attachmentIds}
                            disabled={disabled}
                            onChange={(ids, metadata) => onPhotos(task.seq, ids, metadata)}
                            onStateChange={(blocked, pending) => onPhotoState(task.seq, blocked, pending)}
                            onConflict={onPhotoConflict}
                        />
                    ) : (
                        task.attachmentIds.length > 0 && (
                            <Form.Text>
                                {task.attachmentIds.length} saved reference photos
                            </Form.Text>
                        )
                    )}
                </Form.Group>
            ))}
        </div>
    );
}
